module.exports = __webpack_public_path__ + "static/media/Homecoming - Instrumental Version Cover Art.2a9359d9.jpg";